import React from 'react';

const COMPANIONS = {
  pii: {
    label: 'PII Classification Guide',
    sub: 'What counts as personal data under each law',
    url: 'https://pii.compliancehub.wiki/',
    icon: 'fa-database',
    color: 'text-purple-600',
    bg: 'bg-purple-50 hover:bg-purple-100 border-purple-200',
    badge: 'bg-purple-100 text-purple-700'
  },
  biometric: {
    label: 'Biometric Privacy Laws',
    sub: 'State & federal biometric data requirements',
    url: 'https://biometric.myprivacy.blog/',
    icon: 'fa-fingerprint',
    color: 'text-green-600',
    bg: 'bg-green-50 hover:bg-green-100 border-green-200',
    badge: 'bg-green-100 text-green-700'
  },
  privacyRights: {
    label: 'US Consumer Privacy Rights',
    sub: 'Your state-by-state privacy rights guide',
    url: 'https://privacyrights.compliancehub.wiki/',
    icon: 'fa-shield-halved',
    color: 'text-blue-600',
    bg: 'bg-blue-50 hover:bg-blue-100 border-blue-200',
    badge: 'bg-blue-100 text-blue-700'
  }
};

// Which companions to show and their relevance note per tab
const TAB_CONFIG = {
  all:            { links: ['pii','biometric','privacyRights'], note: null },
  federal:        { links: ['pii','biometric','privacyRights'], note: 'COPPA 2026 amendments added biometrics to personal information definitions' },
  consumerPrivacy:{ links: ['pii','privacyRights','biometric'], note: 'These laws regulate collection of personal data (PII) from minors — see our full PII & privacy rights guides' },
  socialMedia:    { links: ['privacyRights','pii'], note: 'Social media laws restrict how platforms handle minors\' personal data' },
  aadc:           { links: ['pii','biometric','privacyRights'], note: 'AADC laws define default data handling — includes biometric and sensitive data protections' },
  appStore:       { links: ['pii','privacyRights'], note: 'App store laws require age data collection — review PII implications' },
  ageVerification:{ links: ['biometric','pii','privacyRights'], note: 'Many age verification methods use biometric data — see compliance requirements' },
  chatbot:        { links: ['pii','biometric','privacyRights'], note: 'AI chatbots collect sensitive personal and potentially biometric data from minors' },
  international:  { links: ['pii','privacyRights','biometric'], note: 'International laws define PII and privacy rights differently — compare frameworks' }
};

function CompanionResources({ activeTab }) {
  const config = TAB_CONFIG[activeTab] || TAB_CONFIG.all;
  const links = config.links.map(k => COMPANIONS[k]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-4">
      <div className="rounded-lg border border-slate-200 bg-slate-50 p-4">
        <div className="flex items-center gap-2 mb-3">
          <i className="fas fa-link text-gray-400 text-sm"></i>
          <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Related Compliance Tools</span>
          {config.note && (
            <span className="hidden md:inline text-xs text-gray-400 ml-2">— {config.note}</span>
          )}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          {links.map((c, idx) => (
            <a
              key={idx}
              href={c.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`flex items-center gap-3 p-3 rounded-lg border transition-colors ${c.bg}`}
            >
              <div className={`w-8 h-8 rounded-md flex items-center justify-center flex-shrink-0 ${c.badge}`}>
                <i className={`fas ${c.icon} text-sm ${c.color}`}></i>
              </div>
              <div className="min-w-0">
                <div className={`text-sm font-semibold ${c.color} truncate`}>{c.label}</div>
                <div className="text-xs text-gray-500 truncate">{c.sub}</div>
              </div>
              <i className="fas fa-external-link-alt text-xs text-gray-300 ml-auto flex-shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CompanionResources;
